var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-button d-flex align-items-center",on:{"click":_vm.showFilterInterface}},[_c('span',{staticClass:"filter-icon"},[_c('base-filter-icon',{attrs:{"fill":_vm.iconFill}})],1),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.buttonText)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }